/**
 * True once the page has started unloading (refresh / navigation / tab close).
 * Chrome fires `visibilitychange → hidden` and pointer-capture loss during unload; controls must
 * not treat that as "the operator let go" — the server's drop-grace is what keeps a refreshed
 * crew member's hold alive.
 */
let unloading = false;
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => { unloading = true; });
  window.addEventListener("pagehide", () => { unloading = true; });
}
export const isUnloading = () => unloading;
